<template lang="pug">
.upload-container
    .upload-header
        .upload-label
            i.el-icon-paperclip
            span
                slot
        el-upload.upload-action(
            :show-file-list='false',
            :on-change='handleChange',
            action='#',
            :auto-upload='false',
            multiple
        )
            el-button.btn-upload(icon='el-icon-upload2', type='primary', size='small')
                | {{ $t('mensagens.territorio.arquivo.enviar') }}
    
    el-divider(v-if='options.length > 0')
    
    .files-list(v-if='options.length > 0')
        .file-item(v-for='(item, index) in options', :key='index')
            .file-icon
                i.el-icon-document
            .file-info
                .file-name
                    el-link.file-link(
                        v-if='item?.urlDownload',
                        @click.prevent='downloadFile(item)',
                        :underline='false',
                        :title='item.name'
                    )
                        | {{ truncateFileName(item.name) }}
                    span(v-else) {{ truncateFileName(item.name) }}
                .file-size {{ formatFileSize(item?.arquivo?.size ? item?.arquivo?.size : item?.size ? item?.size : item?.fileSize) }}
            .file-actions
                el-button.btn-delete-file(
                    @click='deleteItem(index)',
                    type='text',
                    icon='el-icon-delete',
                    size='small'
                )
    
    .empty-files(v-else)
        i.el-icon-folder-opened.empty-icon
        p.empty-text {{ $t('mensagens.territorio.arquivo.nenhumArquivo') }}
</template>
<script>
// import http from '@/utils/http';

export default {
    props: {
        url: {
            type: String,
            default: ''
        },
        options: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            info: {
                name: '',
                size: '',
                file: {},
                src: ''
            }
        };
    },
    mounted() {
        const val = this.options;
        if (!val) return;
        this.info = {
            name: val?.nomeArquivo,
            size: '',
            file: {},
            src: val?.urlDownload
        };
    },

    methods: {
        handleChange(file) {
            const url = URL.createObjectURL(file.raw);

            const info = {
                name: file.name,
                size: file.size,
                file: file.raw,
                src: url,
                id: file.uid
            };
            this.$emit('add', info);
        },

        deleteItem(index) {
            this.info = {
                name: '',
                size: '',
                file: {},
                src: '',
                id: ''
            };
            this.$emit('delete', index);
        },
        truncateFileName(fileName, maxLength = 40) {
            if (!fileName) return '';
            return fileName.length > maxLength ? fileName.substring(0, maxLength) + '...' : fileName;
        },
        formatFileSize(bytes, decimalPoint) {
            if (bytes === 0) return '0 Bytes';
            var k = 1000;
            var dm = decimalPoint || 2;
            var sizes = [
                'Bytes',
                'KB',
                'MB',
                'GB',
                'TB',
                'PB',
                'EB',
                'ZB',
                'YB'
            ];
            var i = Math.floor(Math.log(bytes) / Math.log(k));
            return (
                parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) +
                ' ' +
                sizes[i]
            );
        },
        downloadFile(item) {
            if (!item?.urlDownload) return;
            
            try {
                const link = document.createElement('a');
                link.href = item.urlDownload;
                link.target = '_blank';
                link.rel = 'noopener noreferrer';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.territorio.arquivo.erroDownload') || 'Erro ao baixar arquivo'
                });
            }
        }
    }
};
</script>
<style scoped lang="scss">
.upload-container {
    width: 100%;
}

.upload-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}

.upload-label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    font-size: 14px;
    color: #5a5a5a;
    
    i {
        font-size: 18px;
        color: var(--primary);
    }
}

.btn-upload {
    box-shadow: 0 2px 4px rgba(64, 158, 255, 0.2);
    
    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 8px rgba(64, 158, 255, 0.3);
        transition: all 0.3s ease;
    }
}

.files-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.file-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    background: #f8f9fa;
    border: 1px solid #e4e7ed;
    border-radius: 6px;
    transition: all 0.3s ease;
    
    &:hover {
        background: #ecf5ff;
        border-color: #b3d8ff;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
    }
}

.file-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: #e1f0ff;
    border-radius: 6px;
    
    i {
        font-size: 20px;
        color: var(--primary);
    }
}

.file-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
}

.file-name {
    font-weight: 600;
    font-size: 14px;
    color: #303133;
}

.file-link {
    color: var(--primary);
    font-weight: 600;
    word-break: break-word;
    
    &:hover {
        color: #66b1ff;
    }
}

.file-size {
    font-size: 12px;
    color: #909399;
    font-weight: 500;
}

.file-actions {
    display: flex;
    align-items: center;
}

.btn-delete-file {
    color: #f56c6c;
    font-size: 18px;
    padding: 8px;
    
    &:hover {
        color: #dc362e;
        background: rgba(245, 108, 108, 0.1);
        border-radius: 4px;
    }
}

.empty-files {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 32px 16px;
    text-align: center;
}

.empty-icon {
    font-size: 48px;
    color: #c0c4cc;
    margin-bottom: 12px;
}

.empty-text {
    font-size: 13px;
    color: #909399;
    margin: 0;
    font-weight: 500;
}
</style>
